import React from 'react';
import SVGIcon from '../components/SVGIcon';
import templateIcon from '../icons/prefilled/template.svg';
import styles from './TemplateIcon.module.scss';

const TemplateIcon = () => {
  return (
    <div className={styles.icon}>
      <SVGIcon>{templateIcon}</SVGIcon>
    </div>
  );
};

export default TemplateIcon;
